import Video from '@cartwhl/ui/atoms/Video';
import Text from '@cartwhl/ui/base/Text';

import { BLOG_ARTICLE_CDN_BASE } from './cdn';

type MediaGridItem =
  | {
      type: 'image';
      cdnKey: string;
      alt: string;
      caption?: string;
    }
  | {
      type: 'video';
      cdnKey: string;
      caption?: string;
    };

interface MediaGridProps {
  items: MediaGridItem[];
}

export default function MediaGrid({ items }: MediaGridProps) {
  if (import.meta.env.DEV && items.length < 2) {
    // Keep authoring feedback lightweight while allowing runtime rendering.
    console.warn('MediaGrid expects at least 2 media items.');
  }

  return (
    <div className="article-breakout my-8 px-4 lg:my-12 lg:px-0">
      <div className="grid grid-cols-2 gap-2 lg:gap-6">
        {items.map((item, index) => (
          <figure key={`${item.cdnKey}-${index}`} className="m-0">
            {item.type === 'image' ? (
              <img
                src={`${BLOG_ARTICLE_CDN_BASE}${item.cdnKey}`}
                alt={item.alt}
                className="w-full rounded-2xl"
                loading="lazy"
              />
            ) : (
              <Video
                src={`${BLOG_ARTICLE_CDN_BASE}${item.cdnKey}`}
                mode="autoplay"
                className="w-full overflow-hidden rounded-2xl"
              />
            )}
            {item.caption && (
              <figcaption className="mt-3">
                <Text
                  as="span"
                  variant="web/body/medium/xs"
                  className="text-tertiary"
                >
                  {item.caption}
                </Text>
              </figcaption>
            )}
          </figure>
        ))}
      </div>
    </div>
  );
}
